import React from "react";
import { Link } from "react-router-dom";
import style from "./BlogCard.module.css";
import truncateIfLong1 from "../../utilities/truncateIfLong1";
import truncateIfLong2 from "../../utilities/truncateIfLong2";

export default function BlogCard({ record, makeItSimilarBlog, makeItReadNextBlog }) {

    return (
        <Link 
            to={`/blogs/blog-detail/${record?.blogId}`} 
            className={`${makeItSimilarBlog && style.SimilarBlogCard} ${makeItReadNextBlog && style.makeItReadNextBlog} ${style.BlogCard}`}
            data-aos="fade-up"
            data-aos-duration="1000"
        >
            <img src={record?.coverImage} alt="Blog" />
            <div>
                <p className={`${makeItReadNextBlog && style.changeColor} ${makeItSimilarBlog && style.makeItSimilarBlog}`}>By <span>{record?.authorName}</span> | {record?.createdAt?.split(" at")[0]}</p>
                <p className={`${makeItReadNextBlog && style.changeColor} ${makeItSimilarBlog && style.SimilarBlogFont}`} title={record?.blogTitle}>{truncateIfLong1(record?.blogTitle, 48)}</p>
                <p className={`${makeItReadNextBlog && style.changeColor} ${makeItSimilarBlog && style.makeItSimilarBlog}`} title={record?.metaDescription}>{truncateIfLong2(record?.metaDescription, 200)}</p>
            </div>
        </Link>
    );    
}